module.exports = __webpack_public_path__ + "static/img/pa4.d7c7191.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/v1/pa4.png
// module id = woeT
// module chunks = 0